module.exports = __webpack_public_path__ + "img/cy.d2e18ce7.svg";